import React from 'react';
import './OutdatedSoftwareCard.css';

const OutdatedSoftwareCard = ({ scanData }) => {
  const outdated = scanData?.outdated_software || [];
  
  if (!outdated || outdated.length === 0) {
    return null;
  }

  return (
    <div className="outdated-software-card">
      <div className="outdated-header">
        <h3>Outdated Software Detected</h3>
      </div>
      <div className="outdated-content">
        {outdated.map((item, idx) => (
          <div key={idx} className="outdated-item">
            <div className="outdated-name">{item.name}</div>
            {item.version && (
              <div className="outdated-version">Version: {item.version}</div>
            )}
            {item.vulnerability_link && (
              <a href={item.vulnerability_link} className="vulnerability-link" target="_blank" rel="noopener noreferrer">
                Vulnerabilities on {item.name}
              </a>
            )}
            <div className="outdated-explanation">
              Our automated scan detects outdated software on your site. Missing security updates can leave your site vulnerable. 
              If you cannot update your site, sign up for virtual patching via our website firewall.
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutdatedSoftwareCard;

